import styled from 'styled-components';

export const StyledBannersContainer = styled.div`
  margin-top: 20px;
`;
